import React, { FunctionComponent } from 'react';
import { Platform, View, Text, Pressable, StyleSheet } from 'react-native';
import { Icon } from '@gluestack-ui/themed';
import { Ionicons } from "@expo/vector-icons";

import { ElementBase, IElementBaseProps, useInitializeElement } from '..';

export const CheckElement: FunctionComponent<IElementBaseProps> = ({ ...props }) => {    
    const {
        element,
        payload, setPayload, errorList
    } = useInitializeElement(props);

    const Toggle = () => {
        const iconColor = element.templateData?.textColor || "#000";
        return payload.value === true ? (
            <Icon 
                style={styles.icon}
                size="lg" 
                name="checkbox-outline" 
                as={Ionicons} 
                color={iconColor}
            />
        ) : (
            <Icon 
                style={styles.icon}
                size="lg" 
                name="square-outline" 
                as={Ionicons} 
                color={iconColor} 
            />
        );
    };

    const changeState = () => {
        if (props.forReview)
            return null;
        setPayload({ ...payload, value: (!payload.value == true) });
    };

    element.templateData.position = element.templateData.position ?? "left";    
    
    const isCenter = element.templateData.position === "center";
    const isRight = element.templateData.position === "right";

    const contentDirection = isCenter 
        ? 'column-reverse' 
        : (isRight ? 'row-reverse' : 'row');

    return (
        <Pressable 
            ref={ref => props.setItemRef && props.setItemRef(ref, element.id)} 
            onPress={changeState}
            style={({ pressed }) => [
                styles.pressable,
                pressed && styles.pressablePressed,
                Platform.OS === "web" && styles.webFlex
            ]}
        >
            <ElementBase 
                boxStyle={styles.elementBase}             
                errors={errorList} 
                element={element} 
                forReview={props.forReview} 
                changedMe={payload.value}
                hideTitleBar={true}
            >
                <View style={[
                    styles.contentContainer,
                    { 
                        alignItems: "center",
                        flexDirection: contentDirection 
                    }
                ]}>                
                    <Toggle />
                    <Text style={[
                        styles.labelText, 
                        { color: element.templateData?.textColor || "#000" }
                    ]}>
                        {element.name ?? element.label}
                    </Text>
                </View>
            </ElementBase>
        </Pressable>
    );
};

const styles = StyleSheet.create({
    pressable: {
        width: "100%",
    },
    webFlex: {
        flex: 1,
    },
    pressablePressed: {
        backgroundColor: "rgba(82, 82, 82, 0.2)",
    },
    elementBase: {
        justifyContent: "center", 
        padding: 10,  
        flexDirection: "column"
    },
    contentContainer: {
        marginBottom: "auto", 
        marginTop: "auto"
    },
    icon: {
        marginHorizontal: 8,
    },
    labelText: {
        fontWeight: "bold",
        flexShrink: 1,
    }
});